/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Menu
  document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu__item');
  
    menuItems.forEach(item => {
      const dropdown = item.querySelector('.header__dropdown');
      const link = item.querySelector(':scope > a'); // Only direct <a> under menu__item
  
      let tappedOnce = false;
  
      const showDropdown = () => {
        menuItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.style.opacity = '0.5';
            const otherDropdown = otherItem.querySelector('.header__dropdown');
            otherDropdown?.classList.remove('is-visible');
          }
        });
        item.style.opacity = '1';
        dropdown?.classList.add('is-visible');
      };
  
      const hideAllDropdowns = () => {
        menuItems.forEach(otherItem => {
          otherItem.style.opacity = '1';
          const otherDropdown = otherItem.querySelector('.header__dropdown');
          otherDropdown?.classList.remove('is-visible');
        });
      };
  
      // Mouse hover support
      item.addEventListener('mouseenter', showDropdown);
      item.addEventListener('mouseleave', hideAllDropdowns);
  
      // Touch support ONLY for top-level <a>
      if (link && dropdown) {
        link.addEventListener('touchstart', function (e) {
          if (!tappedOnce) {
            e.preventDefault(); // Block link on first tap
            showDropdown();
            tappedOnce = true;
  
            setTimeout(() => {
              tappedOnce = false;
            }, 400);
          } else {
            // Follow the link on second tap
            window.location.href = link.href;
          }
        }, { passive: false });
      }
    });
  });

  function throttle(fn, wait) {
    let prev, next;
    return function invokeFn(...args) {
      const now = Date.now();
      next = clearTimeout(next);
      if (!prev || now - prev >= wait) {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
      }
    };
  };

  document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const header = document.querySelector(".header__wrapper");
    const filterNav = document.querySelector(".collection__nav.collection__nav--filter");
    const scrollThreshold = 200; // Hide header after scrolling 200px
  
    function handleScroll() {
      console.log("scrolling"); // Log scrolling event
  
      let scrollTop = window.scrollY || document.documentElement.scrollTop;
  
      if (scrollTop < scrollThreshold) {
        header.classList.remove("header--hidden");
        filterNav?.classList.remove("hidden-filter");
      } else if (scrollTop > lastScrollTop) {
        header.classList.add("header--hidden");
        filterNav?.classList.add("_sticky-filter");
      } else {
        header.classList.remove("header--hidden");
        filterNav?.classList.remove("_sticky-filter");
      }
  
      lastScrollTop = Math.max(scrollTop, 0); // Prevent negative values
    }
  
    window.addEventListener("scroll", throttle(handleScroll, 300)); // Throttle at 100ms
  });

  // top mobile slider
  document.addEventListener('DOMContentLoaded', function () {
    let currentSlide = 1; 
    const slides = document.querySelectorAll('.header-sections .page-multicolumn .grid-item');
    const totalSlides = slides.length - 1; 
    let slideInterval;
    let isPlaying = false; 
    const toggleButton = document.getElementById('toggleButtonPlay');
    const playIcon = document.getElementById('playIcon');
    const pauseIcon = document.getElementById('pauseIcon');

    if (!toggleButton) {
      console.error('Toggle button not found in the DOM.');
      return;
    }

    const changeSlide = () => {
      slides.forEach((slide, index) => {
        if (index !== 0) { 
          slide.style.transform = `translateX(-${(currentSlide - 1) * 100}%)`;
        }
      });

      currentSlide = (currentSlide < totalSlides) ? currentSlide + 1 : 1;
      //console.log(`Current slide: ${currentSlide}`); 
    };

    const startSlider = () => {
      if (!isPlaying) {
        slideInterval = setInterval(changeSlide, 3000); 
        pauseIcon.style.display = 'inline'; 
        playIcon.style.display = 'none'; 
        isPlaying = true;
        //console.log('Slider started'); 
      }
    }; 
    const pauseSlider = () => {
      if (isPlaying) {
        clearInterval(slideInterval);
        playIcon.style.display = 'inline';
        pauseIcon.style.display = 'none'; 
        isPlaying = false;
        //console.log('Slider paused'); 
      }
    };

    // Toggle function for play/pause
    const toggleSlider = () => {
      console.log('Toggle button clicked'); 
      if (isPlaying) {
        pauseSlider();
      } else {
        startSlider();
      }
    };

    // Initialize or destroy the slider based on screen size
    const manageSlider = () => {
      if (window.innerWidth <= 960) {
        if (!isPlaying) {
          startSlider();
        }
      } else {
        if (isPlaying) {
          pauseSlider();
          currentSlide = 1;
          slides.forEach((slide, index) => {
            if (index !== 0) { 
              slide.style.transform = `translateX(0%)`;
            }
          });
        }
      }
    };

    toggleButton.addEventListener('click', toggleSlider);
    manageSlider();
    window.addEventListener('resize', manageSlider);
    if (window.innerWidth <= 960) {
      startSlider(); 
    }

    if (isPlaying) {
      pauseIcon.style.display = 'inline'; 
      playIcon.style.display = 'none'; 
    } else {
      pauseIcon.style.display = 'none'; 
      playIcon.style.display = 'inline'; 
    }
  });

  // mobile menu toggle
  document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.header__mobile__hamburger');
    const mobileNav = document.querySelector('nav.drawer--header'); 
  
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', function () {
        mobileNav.classList.toggle('open');  
        hamburger.classList.toggle('is-active');  

        // Add or remove body class based on mobileNav state
        if (mobileNav.classList.contains('open')) {
          document.body.classList.add('mobile-nav-open');
        } else {
          document.body.classList.remove('mobile-nav-open');
        }   

      });
    }

    const menuButtons = document.querySelectorAll('.drawer__main-menu > .sliderule__wrapper > .sliderow');
    
    menuButtons.forEach(button => {
        button.addEventListener('click', function () {

          const dropdown = this.nextElementSibling;
          const isOpen = dropdown.classList.contains('sub-open');

          document.querySelectorAll('.drawer__main-menu > .sliderule__wrapper > .mobile__menu__dropdown').forEach(dropdown => {
            dropdown.classList.remove('sub-open');
          });
          document.querySelectorAll('.drawer__main-menu > .sliderule__wrapper > .sliderow').forEach(btn => {
            btn.classList.remove('toggle-open'); 
            btn.classList.add('toggle-close');
          }); 

          if (!isOpen) {
            dropdown.classList.add('sub-open');
            this.classList.add('toggle-open');
            this.classList.remove('toggle-close');
          } else {
            dropdown.classList.remove('sub-open');
            this.classList.add('toggle-close');
            this.classList.remove('toggle-open');
          }
        });
    });
 
  });
  
  // Grid - Size selector + add to cart trigger 
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('change', function(event) {
      if (event.target.classList.contains('product-size-radio')) {
        const radio = event.target;
        const form = radio.closest('form');
        const addToCartButton = form.querySelector('[type="submit"]');
        if (addToCartButton) {
          addToCartButton.click();
        }
      }
    });    
  });

   // Trigger notify me on Sold Out button click
   document.addEventListener('DOMContentLoaded', function () {
    // Select all sold out buttons and the modal open link
    const soldOutButtons = document.querySelectorAll(".soldout_button, input.sold-out+label");
    const modalOpenLink = document.querySelector(".product-soldout-notification [data-popup-open]");
    
    // Select the radio buttons in the notification form
    const notificationRadioButtons = document.querySelectorAll('.radio__fieldset input[name="variant"]');
    
    // Select the hidden input field where the variant ID will be stored
    const hiddenVariantInput = document.querySelector('form[data-notification-form] input[name="sold_out_variant_id"]');

    // Function to match and pre-select the radio button in the notification form
    function preselectNotificationRadio(selectedSize) {
      notificationRadioButtons.forEach(radio => {
        if (radio.value === selectedSize) {
          radio.checked = true;
          radio.closest('.radio__button').classList.add('selected');
          
          // Update the hidden input with the selected variant ID
          const selectedVariantId = radio.getAttribute('data-selected-variant');
          if (hiddenVariantInput) {
            hiddenVariantInput.value = selectedVariantId;
          }
        } else {
          radio.checked = false;
          radio.closest('.radio__button').classList.remove('selected');
        }
      });
    }

    // If sold out buttons exist and modal link is available
    if (soldOutButtons.length > 0 && modalOpenLink) {
      soldOutButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          // Trigger a click on the modal open link
          modalOpenLink.click();

          // Get the selected size from the sold-out button
          const selectedSize = button.closest('span').querySelector('input[type="radio"]').value;

          // Pre-select the corresponding radio button in the notification form
          preselectNotificationRadio(selectedSize);
        });
      });
    }
  });
  

  // Add event listener for touchstart (for tablets and touch devices)
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener('touchstart', function(event) {
      const target = event.target.closest('.grid-item.product-item');

      if (target) {
        document.querySelectorAll('.grid-item.product-item.quick-add-active').forEach((el) => {
          el.classList.remove('quick-add-active');
        });

        const outerLink = target.querySelector('a');
        if (outerLink && outerLink.contains(event.target)) {
          //event.preventDefault();
        }
        target.classList.add('quick-add-active');
      }
    }, { passive: false });
  });

  // copy to clipboard
  document.addEventListener("DOMContentLoaded", function() {
    // Get all elements with the class 'copy-clipboard-newsletter'
    const copyClipboardNewsletter = document.querySelectorAll('.copy-clipboard-newsletter');
    const giftCodeInputs = document.querySelectorAll('[data-gift-code]');

    copyClipboardNewsletter.forEach((button, index) => {
        button.addEventListener("click", function() {
            // Get the corresponding input field
            const giftCodeInput = giftCodeInputs[index];

            if (giftCodeInput) {
                // Select the text inside the input field
                giftCodeInput.select();
                giftCodeInput.setSelectionRange(0, 99999); // For mobile devices

                // Copy the text to the clipboard
                navigator.clipboard.writeText(giftCodeInput.value).then(() => {
                    // Temporarily change the input value to indicate success
                    const originalValue = giftCodeInput.value;
                    giftCodeInput.value = "Copied to clipboard";
                    
                    // Revert back to the original value after 2 seconds
                    setTimeout(() => {
                        giftCodeInput.value = originalValue;
                    }, 2000);
                }).catch(err => {
                    console.error("Failed to copy: ", err);
                });
            }
        });
    });
  });

  // FAQS
  document.addEventListener('DOMContentLoaded', function() {
    if (document.body.id === 'frequently-asked-questions') {
        const firstSectionLinks = document.querySelector('.custom-sidebar-tabber .section-sidebar-tabs .widget__links');
        const secondSectionLinks = document.querySelectorAll('.custom-sidebar-tabber .section-sidebar-tabs .widget__links--secondary li');

        const firstSectionAccordion = document.querySelector('.custom-sidebar-tabber .section-sidebar__content collapsible-elements');
        const secondSectionAccordion = document.querySelectorAll('.custom-sidebar-tabber .section-sidebar__content collapsible-elements details');
                
        if (firstSectionLinks && secondSectionLinks.length > 0) {
            secondSectionLinks.forEach(link => {
                const button = link.querySelector('.widget__link');
                if (button && button.classList.contains('is-selected')) {
                    button.classList.remove('is-selected');
                }
                firstSectionLinks.appendChild(link);
            });
            const firstLi = firstSectionLinks.querySelector('li');
            if (firstLi) {
                const firstButton = firstLi.querySelector('.widget__link');
                if (firstButton) {
                    firstButton.classList.add('is-selected');
                }
            }
        } else {
            console.error('First section .widget__links not found or second section .widget__links li is empty');
        }
        //console.log('First Section Links:', firstSectionLinks);
        //console.log('Second Section Links:', secondSectionLinks);

        if (firstSectionAccordion && secondSectionAccordion.length > 0) {
          secondSectionAccordion.forEach(accordion => {
              if (accordion.getAttribute('data-group') !== 'widget_group_1') {
                  accordion.style.display = 'none';
              }

              // Append each accordion to the first section
              firstSectionAccordion.appendChild(accordion);
          });

          const firstAccordion = firstSectionAccordion.querySelector('[data-group="widget_group_1"]');
          if (firstAccordion) {
              firstAccordion.style.display = 'block';
          }
        } else {
          console.error('First section .section-sidebar__content not found or second section .accordion elements are empty');
        }

        //console.log('First Accordion:', firstSectionAccordion);
        //console.log('Second Accordion:', secondSectionAccordion);

    }
  });

  // FAQs hide/show buttons and accordion
  document.addEventListener('DOMContentLoaded', function() {
    if (document.body.id === 'frequently-asked-questions') {
        const firstSectionLinks = document.querySelector('.custom-sidebar-tabber .section-sidebar-tabs .widget__links');
        const firstSectionAccordion = document.querySelector('.custom-sidebar-tabber .section-sidebar__content collapsible-elements');

        firstSectionLinks.querySelectorAll('.widget__link').forEach(button => {
            button.addEventListener('click', function() {
                firstSectionLinks.querySelectorAll('.widget__link').forEach(btn => {
                    btn.classList.remove('is-selected');
                });
                button.classList.add('is-selected');
                const selectedGroup = button.getAttribute('data-group-link');
                firstSectionAccordion.querySelectorAll('details').forEach(accordion => {
                    const accordionGroup = accordion.getAttribute('data-group');
                    if (accordionGroup !== selectedGroup) {
                        accordion.style.display = 'none'; 
                    } else {
                        accordion.style.display = 'block'; 
                    }
                });
            });
        });

        //console.log('First Section Links:', firstSectionLinks);
        //console.log('First Section Accordion:', firstSectionAccordion);
    }
  });
 
  document.addEventListener('DOMContentLoaded', function() {
    const secondSidebarTabber = document.querySelectorAll('#frequently-asked-questions .custom-sidebar-tabber')[1]; 
    if (secondSidebarTabber) {
        secondSidebarTabber.style.display = 'none'; // Hide the second .custom-sidebar-tabber
    }
  });

  // mobile FAQs dropdown
  document.addEventListener('DOMContentLoaded', function() {
    function toggleDropdownOnSmallScreens() {
        if (window.innerWidth < 749) {
            const dropdownButton = document.querySelector('.section-sidebar-tabs .dropdown-button');
            const dropdownList = document.querySelector('.section-sidebar-tabs .widget__links');

            // Check if elements exist before adding event listeners
            if (dropdownButton && dropdownList) {
                // Toggle dropdown visibility on button click
                dropdownButton.addEventListener('click', function() {
                    const isOpen = dropdownList.style.display === 'block';
                    dropdownList.style.display = isOpen ? 'none' : 'block';
                    this.classList.toggle('active', !isOpen);

                    if (!isOpen) {
                        dropdownButton.classList.add('active');
                        dropdownList.classList.add('active');
                    } else {
                        dropdownButton.classList.remove('active');
                        dropdownList.classList.remove('active');
                    }
                });
            }

            const dropdownItems = document.querySelectorAll('.section-sidebar-tabs .widget__link');
            if (dropdownItems.length > 0) {
                dropdownItems.forEach(item => {
                    item.addEventListener('click', function() {
                        const dropdownList = document.querySelector('.section-sidebar-tabs .widget__links');
                        const buttonText = document.querySelector('.section-sidebar-tabs .dropdown-button .button-text');

                        if (buttonText) {
                            buttonText.textContent = this.textContent;
                        }

                        if (dropdownList) {
                            dropdownList.style.display = 'none';
                        }

                        dropdownButton.classList.remove('active');

                        dropdownItems.forEach(link => link.classList.remove('is-selected'));
                        this.classList.add('is-selected');
                    });
                });
            }
        }
    }

    // Run the function on page load
    toggleDropdownOnSmallScreens();

    window.addEventListener('resize', function() {
        const dropdownList = document.querySelector('.section-sidebar-tabs .widget__links');
        const dropdownButton = document.querySelector('.section-sidebar-tabs .dropdown-button');

        if (window.innerWidth >= 749) {
            if (dropdownList) {
                dropdownList.style.display = 'block';
            }
            if (dropdownButton) {
                dropdownButton.classList.remove('active');
            }
        } else {
            toggleDropdownOnSmallScreens();
        }
    });
  });


  document.addEventListener("DOMContentLoaded", function () {
    const upsellContainer = document.querySelector(".cart__widget--products [data-upsell-products]");
    const targetContainer = document.querySelector("#upsell-container");
    const prevBtn = document.querySelector("#prev-btn");
    const nextBtn = document.querySelector("#next-btn");

    if (upsellContainer && targetContainer) {
        const upsellItems = upsellContainer.querySelectorAll("quick-add-product");

        upsellItems.forEach(item => {
            targetContainer.appendChild(item);
        });

        let currentIndex = 0;
        const totalItems = upsellItems.length;
        const itemWidth = targetContainer.clientWidth;

        function updateCarousel() {
            targetContainer.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
        }

        nextBtn.addEventListener("click", function () {
            if (currentIndex < totalItems - 1) {
                currentIndex++;
                updateCarousel();
            }
        });

        prevBtn.addEventListener("click", function () {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarousel();
            }
        });

        window.addEventListener("resize", () => {
            updateCarousel();
        });
    }
  });

  // reload page if 1 item in cart
  function hasItemsInCart() {
    const cartItems = document.querySelectorAll('.drawer__items .cart__item');
    return cartItems.length === 1; 
  }

  function monitorCartItems() {
    const cartItemsContainer = document.querySelector('.drawer__items');
    
    if (cartItemsContainer) {
      const observer = new MutationObserver(() => {
        if (hasItemsInCart()) {
          reloadPageAfterDelay(1500); 
        }
      });

      observer.observe(cartItemsContainer, {
        childList: true,  
        subtree: true,    
      });
    }
  }

  function reloadPageAfterDelay(delayInMilliseconds) {
    setTimeout(() => {
      location.reload(); 
    }, delayInMilliseconds);
  }

  function reopenCartDrawer() {
    setTimeout(() => {
      const cartDrawer = document.querySelector('.drawer--cart');
      const cartBlock = document.querySelector('.cart-block');

      if (cartBlock) {
        cartBlock.classList.add('is-animated');
      }

      if (cartDrawer) {
        cartDrawer.classList.add('is-open', 'is-updated');
      }
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', function () {
    monitorCartItems();

    //if (hasItemsInCart()) {
    //  reopenCartDrawer();
    //}
  });

  // success button text product grid
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("theme:product:add", function (event) {
        const button = event.detail.button;
        const quickAddHolder = button.closest(".quick-add__holder");
        const successMessage = button.closest(".quick_add_message").querySelector(".cart-success-message");

        if (successMessage) {
            successMessage.style.opacity = "1"; 
            successMessage.style.visibility = "visible";

            setTimeout(() => {
                successMessage.style.opacity = "0"; 
                setTimeout(() => {
                    successMessage.style.visibility = "hidden"; 
                }, 500); 
            }, 3000);
        }

        if (quickAddHolder) {
          setTimeout(() => {
              quickAddHolder.style.opacity = "0"; 
              setTimeout(() => {
                  quickAddHolder.style.display = "none"; 
              }, 20);
          }, 100); 
        }        
    });
  });

  // Update sibling product inventory count
  document.querySelectorAll('.sibling_swatch').forEach(function(el) {
    const handle = el.getAttribute('data-handle');
    
    if (handle) {
      fetch(`/products/${handle}.js`)
        .then(response => response.json())
        .then(product => {
          const inStock = product.variants.some(variant => variant.available);
          el.setAttribute('data-available', inStock ? 'in-stock' : 'sold-out');
        })
        .catch(err => {
          console.error('Failed to load product', handle, err);
          el.setAttribute('data-available', 'sold-out'); // fallback
        });
    }
  });

  /** 9 May 2025  */
  // hide out of stock products
  const shownHandles = new Set();
    
    function getTargetSize() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('filter.v.option.size')?.toLowerCase() || null;
    }
    
    // Check if any filter is active in the URL
    function hasActiveFilters() {
      const urlParams = new URLSearchParams(window.location.search);
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('filter.v.option.') && value.trim() !== '') {
          return true;
        }
      }
      return false;
    }
    
    // Check if a size exists in a comma separated sizes string
    function hasSize(sizesStr, size) {
      if (!sizesStr || !size) return false;
      return sizesStr.toLowerCase().split(',').map(s => s.trim()).includes(size);
    }
    
    function applyFilterInGrid() {
      const size = getTargetSize();
      const grid = document.querySelector('#CollectionLoop');
      const pagination = document.querySelector('.pagination-custom');
      const loadMoreBtn = document.getElementById('LoadMoreBtn');
    
      if (!grid) return false;
    
      const filtersActive = hasActiveFilters();
    
      // Show or hide pagination and Load More button
      if (filtersActive) {
        if (pagination) pagination.style.display = 'none';
        if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
      } else {
        if (pagination) pagination.style.display = '';
        if (loadMoreBtn) loadMoreBtn.style.display = 'none';
      }
    
      if (!size) {
        // No size filter, just keep all products visible & track handles
        shownHandles.clear();
        grid.querySelectorAll('.product-item').forEach(card => {
          const handle = card.getAttribute('data-product-handle');
          if (handle) shownHandles.add(handle);
        });
        return true;
      }
    
      // Size filter is present: filter cards that don't have the size
      shownHandles.clear();
      const cards = grid.querySelectorAll('.product-item');
      cards.forEach(card => {
        const sizes = card.getAttribute('data-available-sizes');
        const handle = card.getAttribute('data-product-handle');
        if (!hasSize(sizes, size)) {
          card.remove();
        } else if (handle) {
          shownHandles.add(handle);
        }
      });
    
      return grid.querySelectorAll('.product-item').length > 0;
    }
    
    async function loadNextFilteredPage() {
      // Only load more when filters active
      if (!hasActiveFilters()) {
        return false;
      }
    
      const btn = document.getElementById('LoadMoreBtn');
      if (!btn) return false;
    
      const currentPage = parseInt(btn.dataset.page || '1');
      const nextPage = currentPage + 1;
    
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
    
      try {
        const res = await fetch(url.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('.product-item');
    
        if (newCards.length === 0) {
          btn.style.display = 'none'; // No more products to load
          return false;
        }
    
        const grid = document.querySelector('#CollectionLoop');
        let added = 0;
    
        newCards.forEach(card => {
          const handle = card.getAttribute('data-product-handle');
          const sizes = card.getAttribute('data-available-sizes');
          const size = getTargetSize();
    
          // Add only if not already shown & matches size if size filter applied
          if (
            handle &&
            !shownHandles.has(handle) &&
            (!size || hasSize(sizes, size))
          ) {
            grid.appendChild(card);
            shownHandles.add(handle);
            added++;
          }
        });
    
        if (added === 0) {
          btn.style.display = 'none'; // Hide if no new products appended
          return false;
        }
    
        btn.dataset.page = nextPage.toString();
        return true;
      } catch (err) {
        console.error('Load More Failed:', err);
        return false;
      }
    }
    
    function setupLoadMoreButton() {
      const btn = document.getElementById('LoadMoreBtn');
      if (btn) {
        btn.removeEventListener('click', loadNextFilteredPageHandler);
        btn.addEventListener('click', loadNextFilteredPageHandler);
      }
    }
    
    function loadNextFilteredPageHandler(event) {
      event.preventDefault();
      loadNextFilteredPage();
    }
    
    async function applyFiltersWithLoadMore(autoLoadLimit = 5) {
      const filteredHasProducts = applyFilterInGrid();
      setupLoadMoreButton();
    
      const grid = document.querySelector('#CollectionLoop');
      if (!grid) return;
    
      if (!filteredHasProducts) {
        let tries = 0;
        let loadedAny = false;
        do {
          tries++;
          loadedAny = await loadNextFilteredPage();
        } while (loadedAny && tries < autoLoadLimit && grid.querySelectorAll('.product-item').length === 0);
      }
    
      const btn = document.getElementById('LoadMoreBtn');
      if (btn && grid.querySelectorAll('.product-item').length === 0) {
        btn.style.display = 'none';
      }
    }
    
    function waitForProducts(callback, retries = 20) {
      const grid = document.querySelector('#CollectionLoop');
      if (grid && grid.querySelectorAll('.product-item').length > 0) {
        callback();
      } else if (retries > 0) {
        setTimeout(() => waitForProducts(callback, retries - 1), 250);
      }
    }
    
    document.addEventListener('DOMContentLoaded', () => {
      waitForProducts(applyFiltersWithLoadMore);
    });
    
    const bodyObserver = new MutationObserver(() => {
      waitForProducts(applyFiltersWithLoadMore);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

  // hide 0 reviews
  document.addEventListener("DOMContentLoaded", function() {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('button.yotpo-sr-bottom-line-summary').forEach(button => {
        if (button.innerText.includes('0 Reviews')) {
          button.style.setProperty('display', 'none', 'important');
          console.log('Hidden Yotpo 0-review button');
          observer.disconnect();
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  
})();
